import React, { memo } from 'react';
import CreateButton from './CreateButton/CreateButton';
import { useLang } from '../../util/lang';
import { useHistory } from 'react-router-dom';

const CreateOrderRetainerButton = ({ patientId }) => {
    const get = useLang();
    const history = useHistory();

    const navigate = () => {
        if (!patientId) {
            history.push(`/patients/newPatient/RETAINER`);
        } else {
            history.push(`/patients/${patientId}/samePatient/RETAINER`);
        }
    };
    return (
        <>
            <CreateButton
                name={get('@Patients.orderRetainers')}
                icon="/img/createCase/createCaseIcon/button_icon3.png"
                onClick={navigate}
            />
        </>
    );
};

export default memo(CreateOrderRetainerButton);
